export const validateEmail = (email) => {
  const errors = [];
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!emailRegex.test(email)) {
    errors.push("الاميل غبر مناسب");
  }

  return errors;
};
